<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách ghi nhận KPI</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_FILE_APPROVE')"
          @click="onShowAccountainUpload()"
        >
          <i class="bx bx-upload"></i><span>&nbsp;</span>KT upload file
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="canDeviceKpiSendApproveMx"
          @click="onShowSelectDevice('NEW', dataUser.userId)"
        >
          Gửi duyệt
        </button>
        <!-- kpi record upload add -->
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="canMonitorAction()"
          @click="onShowSelectAction"
        >
          GS thao tác
        </button>
        <button
          v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_FILE_UPLOAD')"
          @click="onViewImportFile"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-import"></i><span>&nbsp;</span>import file KPI
        </button>
        <button class="font-medium f12 btn btn-outline-secondary" @click="exportExcel">
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
        <button class="font-medium f12 btn btn-outline-secondary" @click="kpiSynchronizedStatus">
          <i class="bx bx-sync"></i><span>&nbsp;</span>Đồng bộ trạng thái PLHĐ-PT
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="showModalUpdateStatus = true"
        >
          <i class="bx bx-sync"></i><span>&nbsp;</span>Cập nhật trạng thái nhận file HĐ
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="showModalCreateKpi = true"
        >
          <i class="bx bx-plus"></i><span>&nbsp;</span>Thêm mới KPI
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial/tên MC/gmail MC/SĐT"
              @keyup.enter="submitForm"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="optionsListUser"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.referSource"
              :options="Config.sourceCreate"
              placeholder="Nguồn tạo"
            />
          </div>
          <div class="form-group">
            <SelectMonth v-model="search.month" placeholder="Tháng tính KPI"></SelectMonth>
          </div>
          <div class="form-group">
            <Select2 v-model="search.superiorId" :options="optionsListUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <InputRangeRaw
              v-model="createdDateRange"
              placeholder="Thời gian tạo"
              clearable
              :max-date="new Date()"
            >
            </InputRangeRaw>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.receiptStatus"
              :options="Config.stateReceipt"
              :settings="{ placeholder: 'Trạng thái phiếu thu' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.appendixStatus"
              :options="Config.listStatusContract"
              :settings="{ placeholder: 'Trạng thái phụ lục' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.statusHandovers"
              :options="Config.statusHandoverList"
              :settings="{ placeholder: 'Trạng thái bàn giao' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <!-- statusDeviceKpi -->
            <Select2MultipleControl
              :settings="{ placeholder: 'Trạng thái', closeOnSelect: false }"
              v-model="search.status"
              :options="Config.statusDeviceKpi"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.regionIds"
              :options="dataRegion"
              :settings="{ placeholder: 'Vùng' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.emailSale"
              :options="optionsListUserByEmail"
              placeholder="CVKD"
            />
          </div>

          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              show-empty
              empty-text="Không có dữ liệu!"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchantEmail)="data">
                <p><b>Tên:</b> {{ data.item.merchantName }}</p>
                <p><b>Email:</b> {{ data.item.merchantEmail }}</p>
                <p><b>SĐT:</b> {{ data.item.merchantMobile }}</p>
                <p><b>Địa chỉ:</b> {{ data.item.merchantAddress }}</p>
                <p><b>Loại MC:</b> {{ data.item.merchantType }}</p>
                <p><b>Tình trạng:</b> {{ data.item.isMcLock ? 'Bị khóa' : 'Hoạt động' }}</p>
              </template>

              <template #cell(contractCode)="data">
                <div>
                  {{ data.item.contractCode ? data.item.contractCode : '' }}
                </div>
                <p><b>Phụ lục phí:</b> {{ data.item.isDiscountFee ? 'Ưu đãi' : 'Không ưu đãi' }}</p>
              </template>
              <template #cell(referSource)="data">
                {{
                  data.item.referSource
                    ? data.item.referSource
                    : '' | transformData(Config.sourceCreate)
                }}
              </template>
              <template #cell(formContract)="data">
                {{
                  data.item.formContract
                    ? data.item.formContract
                    : '' | transformData(Config.formContract)
                }}
              </template>
              <template #cell(emailSale)="data">
                <p><b>Tên:</b> {{ data.item.nameSale }}</p>
                <p><b>Email:</b> {{ data.item.emailSale }}</p>
              </template>
              <template #cell(creator)="data">
                <p v-if="data.item.creator"><b>Tên:</b> {{ data.item.creator.name }}</p>
                <p v-if="data.item.creator"><b>Email:</b> {{ data.item.creator.email }}</p>
              </template>
              <template #cell(receiptCode)="data">
                <p>{{ data.item.receiptCode }}</p>
                <p>
                  <span class="badge" :class="data.item.receiptStatus">
                    {{ data.item.receiptStatus | transformData(Config.stateReceipt) }}
                  </span>
                </p>
              </template>
              <template #cell(ratio)="data">
                <p class="text-center" v-if="data.item?.ratio">Mua: {{ data.item?.ratio || '' }}</p>
                <p class="text-center" v-if="data.item?.ratioLending">
                  Mượn: {{ data.item?.ratioLending || '' }}
                </p>
              </template>
              <template #cell(appendixCode)="data">
                <p>{{ data.item.appendixCode }}</p>
                <p>
                  <span class="badge" :class="data.item.appendixStatus">
                    {{ data.item.appendixStatus | transformData(Config.listStatusContract) }}
                  </span>
                </p>
                <div>{{ data.item.typeContract ? data.item.typeContract : '' }}</div>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusDeviceKpi) }}
                </span>
              </template>
              <template #cell(packageType)="data">
                <p v-if="data.item.packageType">Loại gói: {{ data.item.packageType }}</p>
                <p v-if="data.item.duration">Thời hạn: {{ data.item.duration }}</p>
              </template>
              <template #cell(price)="data">
                <p>{{ data.item.price | transformMoney }}</p>
              </template>
              <template #cell(statusHandover)="data">
                <span class="badge" :class="data.item.statusHandover">
                  {{ data.item.statusHandover | transformData(Config.statusHandoverList) }}
                </span>
              </template>
              <template #cell(createdTime)="data">
                <p>{{ data.item.createdTime | formatDate('DD/MM/YYYY HH:mm:ss') }}</p>
              </template>
              <!-- { id: "NEW", text: "Mới tạo" },
                { id: "WAIT_ACCOUNTANT_APPROVE", text: "Chờ kế toán duyệt" },
                { id: "WAIT_MONITOR_APPROVE", text: "Chờ giám sát duyệt" },
                { id: "SALE_ADMIN_ADDITIONAL", text: "SA đã bổ sung" },
                { id: "ACCOUNTANT_REJECT", text: "Kế toán từ chối" },
                { id: "MONITOR_REJECT", text: "Giám sát từ chối" },
                { id: "EXPLANATION", text: "Cần SA giải trình" },
                { id: "ADDITIONAL", text: "Cần SA bổ sung" },
                { id: "SUCCESS", text: "Hoàn thành" } -->
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click="onViewDetail(data.item.id)"
                    ><span>&nbsp;</span>Xem chi tiết
                  </b-dropdown-item>
                  <!-- NEW -->
                  <template v-if="data.item.status === 'NEW'">
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiUpdateMx()"
                      @click="changeDevices(data.item, data.item.serviceType)"
                      ><span>&nbsp;</span>Sửa
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiSendApproveMx()"
                      @click="deviceKpiSendApproveMx([data.item.id])"
                      ><span>&nbsp;</span>Gửi duyệt
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiCancelMx()"
                      @click="deviceKpiCancel([data.item.id])"
                      ><span>&nbsp;</span>Hủy
                    </b-dropdown-item>
                  </template>

                  <template v-if="data.item.status === 'WAIT_ACCOUNTANT_APPROVE'">
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiAccountantApproveMx()"
                      @click="(tempDeviceData = data.item), (showModalAccountantApprove = true)"
                      ><span>&nbsp;</span>KT xác nhận
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiAccountantRejectMx()"
                      @click="deviceKpiAccountantRejectMx([data.item.id])"
                      ><span>&nbsp;</span>KT từ chối
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiAccountantAdditionalMx()"
                      @click="deviceKpiAccountantAdditionalMx([data.item.id])"
                      ><span>&nbsp;</span>Cần bổ sung
                    </b-dropdown-item>
                  </template>

                  <template v-if="data.item.status === 'ADDITIONAL'">
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiSAAdditionalMx()"
                      @click="onShowModalAdminAddtional(data.item)"
                      ><span>&nbsp;</span>Admin bổ sung
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiCancelMx()"
                      @click="deviceKpiCancel([data.item.id])"
                      ><span>&nbsp;</span>Hủy
                    </b-dropdown-item>
                  </template>

                  <template v-if="data.item.status === 'WAIT_MONITOR_APPROVE'">
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiMonitorApproveMx()"
                      @click="deviceKpiMonitorApproveMx([data.item.id])"
                      ><span>&nbsp;</span>GS xác nhận
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiMonitorRejectMx()"
                      @click="deviceKpiMonitorRejectMx([data.item.id])"
                      ><span>&nbsp;</span>GS từ chối
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiMonitorRequestExplanationMx()"
                      @click="deviceKpiMonitorRequestExplanationMx([data.item.id])"
                      ><span>&nbsp;</span>Cần giải trình
                    </b-dropdown-item>
                  </template>

                  <template v-if="data.item.status === 'EXPLANATION'">
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiSAExplanationMx()"
                      @click="onshowModalSAExplanation(data.item)"
                      ><span>&nbsp;</span>Admin giải trình
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="canDeviceKpiCancelMx()"
                      @click="deviceKpiCancel([data.item.id])"
                      ><span>&nbsp;</span>Hủy
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <ModalSAExplanation
      v-model="showModalSAExplanation"
      :dataEdit="tempDeviceData"
      @submit="submitSAExplanation"
      :deviceKpiLogs="historyData"
    ></ModalSAExplanation>
    <ModalEditDevice
      v-model="showModalDevice"
      @submit="submitFormDevice"
      :dataEdit="tempDeviceData"
      :serviceType="tempServiceType"
    ></ModalEditDevice>
    <ModalAccountantApprove
      v-model="showModalAccountantApprove"
      @submit="onAccountantApprove"
    ></ModalAccountantApprove>
    <ModalAdminAddtional
      v-model="showModalAdminAddtional"
      :dataEdit="tempDeviceData"
      @submit="onAdminAddtional"
      :deviceKpiLogs="historyData"
    ></ModalAdminAddtional>

    <ModalSelectDevice
      v-if="showSelectDevice"
      v-model="showSelectDevice"
      :statusKpi="statusKpi"
      @submit="onSubmitListDevice"
      :creatorId="creatorId"
    ></ModalSelectDevice>
    <ModalUpdateStatus
      v-if="showModalUpdateStatus"
      v-model="showModalUpdateStatus"
    ></ModalUpdateStatus>
    <ModalSelectAction
      @onShowSelectDevice="onShowSelectDevice"
      @reloadData="reloadData"
    ></ModalSelectAction>
    <ModalAccountainAction
      @uploadStatusFile="uploadStatusFile"
      @approveKpi="approveKpi"
      @closeModal="onHideAccountUpload"
    >
    </ModalAccountainAction>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <input style="display: none" ref="uploadFileExcel" @change="uploadFileExcel" type="file" />
    <ModalCreateKpi
      v-if="showModalCreateKpi"
      v-model="showModalCreateKpi"
      @reloadData="reloadData"
    ></ModalCreateKpi>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '@/services/device.service'

  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import kpiRecordMx, { getListUserFn, getListUserFnByEmail } from './kpiRecordMx'
  import InputRangeRaw from '../../components/InputRangeRaw.vue'
  import ModalSelectDevice from './components/ModalSelectDevice.vue'
  import ModalAccountantApprove from './components/ModalAccountantApprove.vue'
  import ModalAdminAddtional from './components/ModalAdminAddtional.vue'
  import ModalSAExplanation from './components/ModalSAExplanation.vue'
  import ModalEditDevice from './components/ModalEditDevice.vue'
  import ModalUpdateStatus from './components/ModalUpdateStatus.vue'
  import SelectMonth from './components/SelectMonth.vue'
  import ModalSelectAction from './components/ModalSelectAction.vue'
  import ModalAccountainAction from './components/ModalAccountainAction.vue'
  import ModalCreateKpi from './components/ModalCreateKpi.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'service', label: 'Dịch vụ', thStyle: '' },
    { key: 'merchantEmail', label: 'Merchant', thStyle: 'min-width: 220px' },
    { key: 'contractCode', label: 'Mã hợp đồng', thStyle: '' },
    { key: 'appendixCode', label: 'Mã phụ lục', thStyle: '' },
    { key: 'receiptCode', label: 'Mã phiếu thu', thStyle: '' },
    { key: 'ratio', label: 'Tỷ lệ thiết bị', thStyle: '' },
    { key: 'formContract', label: 'Loại hợp đồng/PL', thStyle: '' },
    { key: 'serial', label: 'Serial TB', thStyle: '' },
    { key: 'price', label: 'GIá tiền' },
    { key: 'createdTime', label: 'Thời gian tạo' },
    { key: 'packageType', label: 'Loại gói & Thời hạn' },
    { key: 'referSource', label: 'Nguồn MC', thStyle: '' },
    { key: 'kpi', label: 'KPI', thStyle: '' },
    { key: 'month', label: 'Tháng tính KPI', thStyle: '' },
    { key: 'emailSale', label: 'CVKD', thStyle: 'min-width: 220px' },
    { key: 'creator', label: 'Người tạo KPI', thStyle: '' },
    { key: 'statusHandover', label: 'Trạng thái bàn giao', thStyle: '' },
    { key: 'status', label: 'Trạng thái', thStyle: '' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  const rawSearch = {
    createDateFrom: null,
    createDateTo: null,
    creatorId: null,
    emailSale: null,
    key: null,
    limit: 20,
    month: null,
    page: 1,
    projectionList: [],
    regionId: null,
    sortResultList: [],
    status: null,
    superiorId: null,
    receiptStatus: null,
    appendixStatus: null,
  }
  export default {
    components: {
      InputRangeRaw,
      ModalSelectDevice,
      ModalAccountantApprove,
      ModalAdminAddtional,
      ModalSAExplanation,
      ModalEditDevice,
      SelectMonth,
      ModalUpdateStatus,
      ModalSelectAction,
      ModalAccountainAction,
      ModalCreateKpi,
    },
    mixins: [kpiRecordMx],

    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        search: cloneDeep(rawSearch),
        pagination: {
          total: 0,
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        createdDateRange: null,

        showSelectDevice: false,
        showModalAccountantApprove: false,
        showModalAdminAddtional: false,
        showModalSAExplanation: false,
        showModalUpdateStatus: false,
        showModalDevice: false,
        tempDeviceData: null,
        tempServiceType: null,
        statusKpi: '',
        creatorId: null,
        historyData: null,

        // option
        optionsListUser: [],
        optionsListUserByEmail: [],
        dataRegion: [],
        canUploadStatusFile: false,
        showModalCreateKpi: false,
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.getListUser()
      this.getRegion()
    },

    methods: {
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      removeForm() {
        this.search = cloneDeep(rawSearch)
        this.createdDateRange = null
        this.fetchData()
      },
      async getRegion() {
        try {
          const data = await StaffService.getListRegions()
          if (data.data && data.data.length > 0) {
            this.dataRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListUser() {
        this.optionsListUser = await getListUserFn()
        this.optionsListUserByEmail = await getListUserFnByEmail()
      },
      onViewDetail(id) {
        const routeData = this.$router.resolve({ path: `/kpi-record/detail/${id}` })
        window.open(routeData.href, '_blank')
      },
      onViewImportFile() {
        const routeData = this.$router.resolve({ name: 'kpi record upload add' })
        window.open(routeData.href, '_blank')
      },
      preareData() {
        this.search.createDateFrom = null
        this.search.createDateTo = null
        if (this.createdDateRange?.start && this.createdDateRange?.end) {
          this.search.createDateFrom = moment(this.createdDateRange.start).startOf('day').valueOf()
          this.search.createDateTo = moment(this.createdDateRange.end).endOf('day').valueOf()
        }
        const params = {
          ...rawSearch,
          ...this.search,
        }
        // remove data null and '0'
        for (const key in params) {
          if (
            params[key] === null ||
            params[key] === '0' ||
            (Array.isArray(params[key]) && params[key].length === 0)
          ) {
            delete params[key]
            delete this.search[key]
          }
        }

        return params
      },
      async fetchData() {
        try {
          this.tbLoading = true

          const params = this.preareData()

          const response = await DeviceService.deviceKpiGetList(params)
          if (response.code === 1000) {
            this.lists = response.data?.kpiAggregateRes
            this.pagination.total = response.data?.count
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
      checkIsOverRangeDay(day1, day2, maxDay) {
        const dayM1 = moment(day1)
        const dayM2 = moment(day2)
        const diff = Math.abs(dayM1.diff(dayM2, 'days')) + 1
        if (diff <= maxDay) return false
        else return true
      },
      async exportExcel() {
        try {
          const params = this.preareData()
          delete params.page
          delete params.limit
          // check date
          if (!params.createDateFrom || !params.createDateTo) {
            this.showFailMx('Vui lòng chọn thời gian tạo (không quá 2 tháng) trước khi xuất excel')
            return
          }
          if (this.checkIsOverRangeDay(params.createDateFrom, params.createDateTo, 62)) {
            this.showFailMx('Thời gian tạo không được vượt quá 2 tháng')
            return
          }

          this.showLoading = true
          await DeviceService.kpiExportExcel(params)
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      onShowSelectDevice(status, creatorId = null) {
        if (!status) return
        this.statusKpi = status
        this.creatorId = creatorId
        this.showSelectDevice = true
        this.$bvModal.hide('select-action')
      },
      async onAccountantApprove(data) {
        const isDone = await this.deviceKpiAccountantApproveMx({
          ...data,
          ids: [this.tempDeviceData.id],
        })
        if (isDone) {
          this.showModalAccountantApprove = false
          this.tempDeviceData = null
          this.showSuccessMx('Kế toán xác nhận thành công')
        }
      },
      async onAdminAddtional(data) {
        const isDone = await this.deviceKpiSAAdditionalMx({
          ...data,
          id: this.tempDeviceData.id,
        })
        if (isDone) {
          this.showModalAdminAddtional = false
          this.tempDeviceData = null
          this.historyData = null
        }
      },
      // sửa
      changeDevices(device, serviceType) {
        if (!device || !serviceType) {
          this.showFailMx('Không có đủ thông tin thiết bi')
          return
        }
        this.tempServiceType = serviceType
        this.tempDeviceData = { ...device }
        this.tempDeviceData.kpi = String(device.kpi)
        // this.showModalDevice = true
        this.$nextTick(s => (this.showModalDevice = true))
      },
      async submitFormDevice({ data, serviceType }) {
        const params = { ...data, serviceType }
        const isDone = await this.deviceKpiUpdateMx(params)
        if (isDone) {
          this.showModalDevice = false
          this.showSuccessMx('Đã cập nhập thiết bị thành công')
        }
      },

      async onSubmitListDevice(ids) {
        const status = this.statusKpi

        // gửi duyệt NEW
        if (status === 'NEW') {
          const data = await this.deviceKpiSendApproveMx(ids)
          if (data) {
            this.showSelectDevice = false
          }
        }

        // dám sát duyệt WAIT_MONITOR_APPROVE
        if (status === 'WAIT_MONITOR_APPROVE') {
          const data = await this.deviceKpiMonitorApproveMx(ids)
          if (data) {
            this.showSelectDevice = false
          }
        }
      },
      async deviceKpiCancel(ids) {
        await this.deviceKpiCancelMx(ids)
      },

      // admin giai trinh
      async submitSAExplanation(data) {
        const isDone = await this.deviceKpiSAExplanationMx({
          ...data,
          ids: [this.tempDeviceData.id],
        })
        if (isDone) {
          this.showSuccessMx('SA giải trình thành công')
          this.tempDeviceData = null
          this.showModalSAExplanation = false
          this.historyData = null
        }
      },
      async deviceKpiGetLogs(id) {
        try {
          this.showLoading = true
          const params = {
            id,
          }
          const response = await DeviceService.deviceKpiGetLogs(params)
          if (response.code === 1000) {
            return response.data
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showLoading = false
          this.showFailMx(error.message ?? error)
          return []
        } finally {
          this.showLoading = false
        }
      },

      // admin bo sung
      async onShowModalAdminAddtional(data) {
        this.tempDeviceData = data
        this.historyData = await this.deviceKpiGetLogs(data.id)
        this.showModalAdminAddtional = true
        this.$nextTick(s => (this.showModalAdminAddtional = true))
      },
      // admin giai trinh
      async onshowModalSAExplanation(data) {
        this.tempDeviceData = data
        this.tempDeviceData.kpi = String(data.kpi)
        this.historyData = await this.deviceKpiGetLogs(data.id)
        this.showModalSAExplanation = true
      },

      // KT upload
      async uploadFileExcel(file) {
        const check = this.dataPermission.includes(
          'CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_FILE_APPROVE'
        )
        if (!check) {
          this.showFailMx('Không có quyền truy cập')
          return false
        }

        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        try {
          this.showLoading = true
          const res = await DeviceService.kpiReadFileApproveAcount(formdata)
          if (res.code === 1000) {
            const { listError, listCorrect } = res.data
            if (listError.length === 0) {
              this.listDevice = listCorrect
              this.fileName = file.target.files[0].name
            }
            this.showMsgOk(res.data)
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.showLoading = false
        }
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.listCorrect.length),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.listError.length),
            ' bản ghi',
          ]),
          data.listError.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.listError),
                },
              },
              `Tải bản ${data.listError.length} ghi thất bại`
            ),
          data.listError.length === 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-primary ml-2',
                on: {
                  click: () => this.onAccountantApproveList(data.listCorrect),
                },
              },
              `Cập nhật kết quả ${data.listCorrect.length} bản ghi`
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
          id: 'msgOkModal',
        })
      },
      closeMsgOkModal() {
        this.$bvModal.hide('msgOkModal')
      },
      async dowloadFileError(reqs) {
        try {
          this.showLoading = true
          await DeviceService.kpiKTDownloadFileError(reqs)
        } finally {
          this.showLoading = false
        }
      },
      async onAccountantApproveList(data) {
        if (this.canUploadStatusFile === true) {
          this.onAccountantUploadStatusFile(data)
        } else {
          const check = this.canDeviceKpiAccountantApproveMx()
          if (!check) {
            this.showFailMx('Không có quyền truy cập')
            return false
          }
          try {
            this.showLoading = true
            const kpiNotes = data.map(e => {
              const item = {
                id: e.id,
                note: e.note,
                statusFileContract: this.getId(
                  e.statusFileContract,
                  this.statusFileContractOptions
                ),
                statusPayment: this.getId(e.statusPayment, this.statusPaymentOptions),
              }
              return item
            })
            const params = {
              kpiNotes,
            }
            const response = await DeviceService.deviceKpiAccountantApprove(params)
            if (response.code === 1000) {
              this.showSuccessMx('Kế toán xác nhận thành công')
              this.fetchData()
              return true
            } else {
              throw new Error(response.message)
            }
          } catch (error) {
            console.log(error)
            this.showFailMx(error.message ?? error)
            return false
          } finally {
            this.showLoading = false
            this.canUploadStatusFile = false
            this.onHideAccountUpload()
            this.closeMsgOkModal()
          }
        }
      },
      async onAccountantUploadStatusFile(data) {
        const check = this.canDeviceKpiAccountantApproveMx()
        if (!check) {
          this.showFailMx('Không có quyền truy cập')
          return false
        }
        try {
          this.showLoading = true
          const listReq = data.map(e => {
            const item = {
              id: e.id,
              statusFileContract: this.getId(e.statusFileContract, this.statusFileContractOptions),
            }
            return item
          })
          const params = {
            listReq,
          }
          const response = await DeviceService.deviceKpiAccountantUploadStatusFile(params)
          if (response.code === 1000) {
            this.showSuccessMx('Kế toán xác nhận thành công')
            this.fetchData()
            return true
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
          return false
        } finally {
          this.showLoading = false
          this.onHideAccountUpload()
          this.closeMsgOkModal()
        }
      },

      getId(text, option) {
        const finded = option.find(e => e.text === text)
        return finded ? finded.id : null
      },
      // đông bộ
      async kpiSynchronizedStatus() {
        try {
          this.showLoading = true
          const response = await DeviceService.kpiSynchronizedStatus()
          if (response.code === 1000) {
            this.showLoading = false
            this.showSuccessMx('Đồng bộ trạng thái PLHĐ-PT thành công')
            this.fetchData()
            return true
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
          return false
        } finally {
          this.showLoading = false
        }
      },
      onShowSelectAction() {
        this.$bvModal.show('select-action')
      },
      onShowAccountainUpload() {
        this.$bvModal.show('select-accountain-action')
      },
      onHideAccountUpload() {
        this.$bvModal.hide('select-accountain-action')
        this.cancanUploadStatusFile = false
      },
      reloadData() {
        this.fetchData()
      },
      approveKpi() {
        this.$refs.uploadFileExcel.click()
      },
      uploadStatusFile() {
        this.canUploadStatusFile = true
        this.$refs.uploadFileExcel.click()
      },
    },
  }
</script>

<style scoped>
  @import './commonStyles.css';
</style>

<style scoped></style>
